package nl.appstuff.padelchecker.site

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import org.jetbrains.compose.web.css.*

/**
 * Global CSS registered via Silk's stylesheet mechanism.
 *
 * Inside [registerStyleBase], the lambda must return a [Modifier].
 * For arbitrary CSS properties not covered by Modifier extensions, use [styleModifier].
 * Inside [styleModifier] the receiver IS Compose HTML's StyleScope so `property(key, value)` works.
 */
@InitSilk
fun initGlobalStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("*, *::before, *::after") {
        Modifier.styleModifier {
            property("box-sizing", "border-box")
        }
    }

    ctx.stylesheet.registerStyleBase("html") {
        Modifier.styleModifier {
            property("scroll-behavior", "smooth")
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .margin(0.px)
            .padding(0.px)
            .styleModifier {
                property(
                    "font-family",
                    "'Roboto', 'Segoe UI', Helvetica, Arial, sans-serif",
                )
                property("-webkit-font-smoothing", "antialiased")
                property("-moz-osx-font-smoothing", "grayscale")
                property("background-color", "#F7F7F7")
            }
    }

    ctx.stylesheet.registerStyleBase("img") {
        Modifier.maxWidth(100.percent).styleModifier {
            property("height", "auto")
        }
    }

    ctx.stylesheet.registerStyleBase("a") {
        Modifier.styleModifier {
            property("text-decoration", "none")
        }
    }
}
